
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Table } from '../../../admin/components/Table/Table'
import CardProductOutput from '../../../admin/containers/Inventory/transfer/Cards/CardProductOutput'
import Button from '../../../utils/components/Button/Button'
import { formatPrice } from '../../../utils/functions'
import useModal from '../../../utils/hooks/useModal'
import { Translate } from '../../../language'
import { SaleRegister } from '../../../assets/icons'
import plusCircle from '../../../assets/img/plusCircle.png'
import TitleSVG from '../../../utils/components/TitleSVG/TitleSVG'
import style from './InventoryDetail.module.css'
import { clearBatches } from '../../../actions/inventoryActions'
import { clearBatchesByProduct } from '../../../admin/actions/wineryBatchesActions'

const InventoryDetaill = ({ sale, subSales, getBatches, manageSaleFn }) => {
    const [subSale, setSubSale] = useState(null)
    const dispatch = useDispatch()
    const [refModal, isShowModal, setIsShowModal] = useModal(false)
    const [specifications, setSpecifications] = useState([])

    const [batchesList, setBatchesList] = useState(new Map())
    const [subOrderState, setSubOrder] = useState(null)
    useEffect(() => {
        if (!isShowModal) {
            dispatch(clearBatches())
        }
    }, [isShowModal])





    return (
        <div>

            {sale?.status ===0 ?
                <TitleSVG Icon={SaleRegister} titleHighlight={Translate('registerText', 'es')} title={Translate('saleRegisterTitle', 'es')} /> :
                <TitleSVG Icon={SaleRegister} titleHighlight={Translate('details', 'es')} title={Translate('ofOrder', 'es')} />
            }


            <div className={style.table_container}>
                <Table style={style}>
                    <thead>
                        <tr>
                            <th>Código</th>
                            <th>Nombre</th>
                            <th>Precio unitario</th>
                            <th>Cantidad</th>
                            <th>Subtotal</th>
                            {sale?.status ===0 &&
                                <th>Gestionar</th>
                            }

                        </tr>
                    </thead>
                    <tbody>
                        {
                            subSales.map(subSale => (
                                <tr>
                                    <td>{subSale.productId.code}</td>
                                    <td>{subSale.productId.name}</td>
                                    <td>{formatPrice(subSale.unitPrice)}</td>
                                    <td>{subSale.orderedQuantity}</td>
                                    <td>{formatPrice(subSale.totalPrice)}</td>

                                    {sale?.status ===0 &&


                                        <td className={`${style.add_button}`} >
                                            <img
                                                className="animate__animated animate__bounceIn"
                                                onClick={() => {
                                                    getBatches(subSale.productId._id)
                                                    setSubOrder(subSale)


                                                    if (specifications.find(specification => specification.subOrderId ===subSale._id) ===undefined) {
                                                        setBatchesList(new Map())
                                                    } else {
                                                        const batches = specifications.find(specification => specification.subOrderId ===subSale._id).batches
                                                        console.log();
                                                        setBatchesList(new Map(batches.map(batch => [batch._id, batch])))
                                                    }


                                                    setIsShowModal(true)

                                                }}
                                                src={plusCircle}
                                                height={30}
                                                alt="" />
                                        </td>




                                    }
                                </tr>
                            ))
                        }

                    </tbody>
                </Table>
                <div className={`${style.total_text}`}>
                    Precio total: {sale?.totalPrice && formatPrice(sale.totalPrice)}
                </div>
                {sale?.status ===0 &&
                    <div className='column centerContent'>
                        <Button
                            disabled={specifications.length < subSales.length}
                            onClick={() => {
                                const specificationsArray = specifications.map(specification => {
                                    return {
                                        subOrderId: specification.subOrderId,
                                        batches: specification.batches.map(batch => batch._id)
                                    }
                                })
                                // console.log();
                                console.log();
                                manageSaleFn(specificationsArray)
                            }}
                            text='Guardar' />
                    </div>
                }
            </div>




            <ModalBatches
                batchesList={batchesList}
                setBatchesList={setBatchesList}
                subSale={subOrderState}
                isShowModal={isShowModal}
                setSpecifications={setSpecifications}
                close={() => {

                    setBatchesList(new Map());
                    setIsShowModal(false)
                }} />



        </div>
    )
}

const ModalBatches = ({ batchesList, setBatchesList, subSale, isShowModal, setSpecifications, close }) => {
    const divStyle = {
        display: isShowModal ? 'block' : 'none'
    };
    const dispatch = useDispatch()
    const { batchesProduct } = useSelector(state => state.inventory)

    if (!subSale) {
        return <></>
    }

    const totalStockBatches = Array.from(batchesList.values()).reduce((n, { quantityStock }) => n + quantityStock, 0);
    const amountRemaining = (subSale.orderedQuantity - totalStockBatches > 0) ? subSale.orderedQuantity - totalStockBatches : 0


    return (
        <div style={divStyle}
            className="modal">
            <div className="modal-content modal-report-post" >
                <div>
                    <div className={`admin-subtitle flex-row-center`}>
                        Seleccione donde saldrán {subSale.orderedQuantity} cantidades del producto: {subSale.productId.name}
                        <span>
                            {subSale.orderedQuantity - amountRemaining} de {subSale.orderedQuantity}
                        </span>
                    </div>

                    <div className={`admin-subtitle flex-row-center`}>
                        {subSale.orderedQuantity ===1 ? <span> Seleccione de donde saldrá {subSale.orderedQuantity} unidad del producto: {subSale.productId.name}</span> :
                            <span> Seleccione de donde saldrán {subSale.orderedQuantity} unidades del producto: {subSale.productId.name}</span>}
                    </div>
                    <div>
                        {
                            batchesProduct.map(batch => (
                                <CardProductOutput
                                    checked={batchesList.has(batch._id)}
                                    index={Array.from(batchesList).findIndex(([key]) => key ===batch._id)}
                                    expeditionDate={batch.expeditionDate}
                                    expirationDate={batch.expirationDate}
                                    name={batch.wineryId.name}
                                    code={batch.code}
                                    stock={batch.quantityStock}
                                    id={batch._id}
                                    handleOnChange={() => {

                                        setBatchesList(oldList => {


                                            const unsortedArray = [...oldList]

                                            const sortedArray = unsortedArray.sort(([key1, batch1], [key2, batch2]) => {
                                                return new Date(batch1.expirationDate) - new Date(batch2.expirationDate)
                                            }
                                                //  key1.localeCompare(key2)

                                            )
                                            const newList = new Map(sortedArray)
                                            if (newList.has(batch._id)) {
                                                newList.delete(batch._id)
                                            } else {
                                                //     const newTotal = [...Array.from(newList.values()),batch].reduce((n, { quantityStock }) => n + quantityStock, 0);

                                                if (amountRemaining > 0) {



                                                    newList.set(batch._id, batch)
                                                }


                                            }
                                            return newList;

                                        })
                                    }}
                                />
                            ))
                        }
                    </div>
                </div>

                <div className={`margin-top-20 flex-row-center admin-subtitle admin-highlight-text`}>
                    {subSale.orderedQuantity - amountRemaining} de {subSale.orderedQuantity}
                </div>
                <div className='flex-row-center column mt-5'>
                    <Button
                        disabled={amountRemaining > 0}
                        onClick={() => {
                            setSpecifications(specification => {
                                return [...specification, {
                                    subOrderId: subSale._id,
                                    batches: Array.from(batchesList.values())
                                }]
                            })

                            close()
                        }} text="Guardar" />
                    <Button onClick={() => {
                        close()
                    }} text="Cancelar" />
                </div>


            </div>
        </div>
    )

}

export default InventoryDetaill